<template>
  <PaperCard :has_header="false">
    <template #body>
      <div>
        <p class="text-strongest text-lg font-semibold font-inter mb-[.375rem]">
          Select the joint contact
        </p>
        <p class="text-strong text-sm font-medium font-inter">
          Joint contact you are buying the bonds with
        </p>
      </div>
      <div>
        <div class="grid grid-cols-2 gap-4 mt-8 mb-4">
          <div
            v-if="dataStore.joint_contacts?.length > 0"
            v-for="contact in dataStore.joint_contacts"
            @click="purchaseFlowStore.active_joint_contact = contact"
            class="cursor-pointer col-span-2 lg:col-span-1 rounded-xl p-4 flex items-center justify-between gap-3 h-[64px] lg:h-[85px]"
            :class="isJointContactSelected(contact.record_id) ? 'bg-radio-checkbox-selector' : ''"
          >
            <div class="flex items-center gap-5">
              <div
                class="h-6 w-6 rounded-full flex items-center justify-center border border-radio-checkbox-outline"
                :class="
                  isJointContactSelected(contact.record_id)
                    ? 'bg-radio-checkbox-checked border-transparent'
                    : 'bg-transparent border border-radio-checkbox-outline'
                "
              >
                <Icon
                  v-if="isJointContactSelected(contact.record_id)"
                  name="Check"
                  class="text-container-bg h-4.5 w-4.5"
                  :stroke-width="2.5"
                />
              </div>
              <div>
                <p
                  class="font-inter whitespace-nowrap text-sm lg:text-lg text-strongest"
                  :class="
                    isJointContactSelected(contact.record_id) ? 'font-semibold' : 'font-medium'
                  "
                >
                  {{ contact.first_name }} {{ contact.last_name }}
                </p>
                <p
                  class="text-sm lg:text-base font-semibold font-inter"
                  :class="
                    isJointContactSelected(contact.record_id) ? 'text-stronger' : 'text-strong'
                  "
                >
                  {{ signedInvestmentsForJointContact(contact.record_id).length }} investment{{
                    signedInvestmentsForJointContact(contact.record_id).length === 1 ? "" : "s"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <Button @click="handleNewJointContactSelection" variant="paper-primary">
          <template #label>Add new joint contact</template>
          <template #icon>
            <Icon name="Plus" class="h-4 w-4" :stroke-width="3" />
          </template>
        </Button>
      </div>
    </template>
  </PaperCard>
</template>

<script setup>
import { usePurchaseFlowStore, useDataStore } from "@/stores";
import { PaperCard, Icon, Button } from "@/components";
import { JOINT_TEMPLATE } from "@/constants";

const purchaseFlowStore = usePurchaseFlowStore();
const dataStore = useDataStore();

function isJointContactSelected(joint_contact_record_id) {
  return purchaseFlowStore.active_joint_contact.record_id === joint_contact_record_id;
}

function signedInvestmentsForJointContact(joint_contact_record_id) {
  return dataStore.investments.filter(
    (investment) =>
      investment.joint_contact_id === joint_contact_record_id && investment.signature_date
  );
}

function handleNewJointContactSelection() {
  purchaseFlowStore.active_joint_contact = JOINT_TEMPLATE;
  purchaseFlowStore.current_substep = 2;
}
</script>
